import ModalEvidence from './modal-evidence.component'

export { ModalEvidence }
